import { useList } from '@refinedev/core';

export type RemoteDoc = {
  id: string;
  name: string;
  isFolder: boolean;
  isFile: boolean;
  driveId: string;
  downloadUrl: string | null;
  parent: {
    id: string | null;
    name: string | null;
    parentId: string | null;
  } | null;
};

export type SharepointDocsProps =
  | {
      driveId: null;
      childId: null;
    }
  | {
      driveId: string;
      childId?: string | null;
    };

export const useSharepointDocs = (
  { driveId, childId }: SharepointDocsProps = { driveId: null, childId: null },
) => {
  function getResource(): string {
    if (driveId && childId) {
      return `sharepoint-docs/drives/${driveId}/children/${childId}`;
    } else if (driveId) {
      return `sharepoint-docs/drives/${driveId}/children`;
    } else {
      return 'sharepoint-docs';
    }
  }

  const { data, isLoading, isError } = useList<RemoteDoc>({
    resource: getResource(),
  });

  return {
    docs: data?.data,
    isLoading,
    isError,
  };
};
